import axios from '../axios'

/*
 * 服务技能申请列表
 */

export const selectByPage = (data) => {
    return axios({
        url: '/memberProjectProduct/selectByPage',
        method: 'post',
        data
    })
}



export const batchApprove = (data) => {
    return axios({
        url: '/memberProjectProduct/batchApprove',
        method: 'post',
        data
    })
}

export const batchReject = (data) => {
    return axios({
        url: '/memberProjectProduct/batchReject',
        method: 'post',
        data
    })
}

export const pull = (data) => {
    return axios({
        url: '/memberProjectProduct/pull',
        method: 'post',
        data
    })
}
export const batchApproveBackgroundPic = (data) => {
    return axios({
        url: '/memberProjectProduct/batchApproveBackgroundPic',
        method: 'post',
        data
    })
}
export const batchRejectBackgroundPic = (data) => {
    return axios({
        url: '/memberProjectProduct/batchRejectBackgroundPic',
        method: 'post',
        data
    })
}

export const batchPullTransferReject = (data) => {
    return axios({
        url: '/memberProjectProduct/batchPullTransferReject',
        method: 'post',
        data
    })
}

export const batchDelete = (data) => {
    return axios({
        url: '/memberProjectProduct/batchDelete',
        method: 'post',
        data
    })
}







// WEBPACK FOOTER //
// ./src/http/play/serviceapply.js